import { Component } from '@angular/core';

@Component({
  selector: 'kp-auth-sso-logout',
  templateUrl: './auth-sso-logout.component.html',
  styleUrls: ['./auth-sso-logout.component.scss'],
})
export class AuthSsoLogoutComponent {}
